export default "__VITE_ASSET__ef6e5a24__"